<template lang="pug">
    div
        Input(
            :value="value"
            @on-change="updateParent"
            :placeholder="placeholder"
            :autosize="autosize"
            :type="fieldType"
            :disabled="disabled"
        )
        Row(v-if="formItem.quickAddProps" style="margin-top: 4px;")
            Button(size="small" type="default" icon="md-add"  @click="showQuickAddProps = !showQuickAddProps") {{ $i18n.t("rcmtable.quickAdd") }}
        Row(v-if="showQuickAddProps" v-for="(quickAddProp, quickAddPropIndex) in formItem.quickAddProps" :key="quickAddPropIndex" :gutter="8")
            Col(:sm="24" :md="6")
                Row(align="middle")
                    Col
                        p {{quickAddProp.title}}
                    Col
                        Poptip(word-wrap width="300" :content="quickAddProp.description" placement="right")
                            Icon(type="ios-information-circle-outline" style="padding: 2px")
            Col(:sm="24" :md="18")
                Button(size="small" v-for="(item, index) in quickAddProp.templateData" :key="index" @click="quickAdd(item)") {{ item.label }}
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            placeholder: this.formItem.placeholder || "",
            autosize: this.formItem.autosize || false,
            fieldType: this.formItem.fieldType || "text",
            showQuickAddProps: false,
        };
    },
    methods: {
        updateParent(event) {
            this.$emit("input", event.target.value);
            if (typeof this.formItem.watchField === "function") {
                this.formItem.watchField(event.target.value, this.formData);
            }
        },
        quickAdd(item) {
            this.updateParent({ target: { value: this.value ? `${this.value}\n${item.value}` : item.value } });
        },
    },
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Input.vue